import React, { useState, useEffect } from "react";
import DeactivateYourCompany from "../../../components/Organisation/DeactivateYourCompany";
import ManageOrganisationTable from "../../../components/Organisation/ManageOrganisationTable";
import RenameOrganisation from "../../../components/Organisation/RenameOrganisation";
import SuccessAlert from "../../../components/UI/Alert/SuccessAlert";
import { useUserContext } from "../../../contexts/UserContext";
import Loader from "../../../components/UI/Loader/Loader";
import { useContentfulContext } from "../../../contexts/ContentfulContext";

const Company = () => {
  const { userData, loading } = useUserContext();
  const { content } = useContentfulContext();
  const [deactivateCompany, setDeactivateCompany] = useState(false);
  const [renameOrganisation, setRenameOrganisation] = useState(false);
  const [organisationData, setOrganisationData] = useState([]);
  const [defaultSuccess, setDefaultSuccess] = useState(false);
  const [selectedOrganisation, setSelectedOrganisation] = useState();

  useEffect(() => {
    let newOrgData = [...(userData?.organizations || [])];

    newOrgData = newOrgData.map((org) => {
      return {
        ...org,
        default: userData?.user_metadata?.default_organization === org.name ? "YES" : "NO",
        role: org?.role?.map((role) => role.name).join(", "),
      };
    });

    newOrgData.sort(function (a, b) {
      if (a.display_name < b.display_name) return -1;
      if (a.display_name > b.display_name) return 1;
      return 0;
    });
    setOrganisationData([...newOrgData]);
  }, [userData]);

  if (deactivateCompany) {
    return (
      <DeactivateYourCompany
        setDeactivateCompany={setDeactivateCompany}
        selectedOrganisation={selectedOrganisation}
      />
    );
  }
  if (renameOrganisation) {
    return (
      <RenameOrganisation
        setRenameOrganisation={setRenameOrganisation}
        organisationData={organisationData}
        setOrganisationData={setOrganisationData}
        selectedOrganisation={selectedOrganisation}
        setSelectedOrganisation={setSelectedOrganisation}
      />
    );
  }

  return (
    <>
      {loading && <Loader />}
      <main id="main" className="stride-page-shell flex flex-col space-y-6">
        <div>
          <span className="stride-eyebrow">Settings / Organization</span>
          <h1 className="text-2xl font-bold tracking-tight text-stride-heading">
            {content.COMPANY_CONTENT.title}
          </h1>
          <p className="text-sm text-stride-muted mt-1">
            {content.COMPANY_CONTENT.description}
          </p>
        </div>

        {defaultSuccess && (
          <SuccessAlert
            disappearTime={content.COMPANY_CONTENT.success_alert.timeout}
            onDisappear={() => {
              setDefaultSuccess(false);
            }}
          >
            {content.COMPANY_CONTENT.errors.FE124}
          </SuccessAlert>
        )}

        <div className="w-full">
          <ManageOrganisationTable
            organisationData={organisationData}
            setOrganisationData={setOrganisationData}
            setRenameOrganisation={setRenameOrganisation}
            setDeactivateCompany={setDeactivateCompany}
            setDefaultSuccess={setDefaultSuccess}
            setSelectedOrganisation={setSelectedOrganisation}
            selectedOrganisation={selectedOrganisation}
          />
        </div>
      </main>
    </>
  );
};

export default Company;
